import { Component, OnInit, Input } from "@angular/core";
import { TranslatedBaseError } from "../TranslatedBaseError";
import { ServiceGroup } from "src/app/models/service-group";

@Component({
    selector: "group-manage",
    templateUrl: "./group-manage.component.html",
})
export class GroupManageComponent extends TranslatedBaseError implements OnInit {

    @Input() public group: ServiceGroup;

    public ngOnInit() {
        console.log("--- Group", this.group);
    }
}
